/**
 * Pull up to two initials from a player name — first letter of the first
 * word + first letter of the last word (uppercased). Falls back to `?`
 * when the name is empty.
 *
 * Used wherever a player headshot is expected but no photo is available:
 * match events timeline, squad listings, team-featured players, etc.
 */
export function initialsFromName(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "?";
    const first = words[0][0] ?? "";
    const last = words.length > 1 ? words[words.length - 1][0] ?? "" : "";
    const initials = (first + last).toUpperCase();
    return initials || "?";
}
